import styled from 'styled-components';

export const InstagramWrapper = styled.div`

`;

export const InstagramTitle = styled.h2`
  text-align: center;
  font-size: 2rem;
  letter-spacing: 8px;
`;

export const MainLayoutWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const LeftSideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 25%;
`;

export const RightSideWrapper = styled.div`
  background-color: #ffdb26;
  width: 75%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`;

export const UpImageWrapper = styled.div`
  height: 30rem;
  margin: 1rem;
`;

export const UpImage = styled.img`
  width: 100%;
  height: 100%;
`;

export const BottomImageWrapper = styled.div`
  height: 20rem;
  margin: 1rem;
`;

export const BottomImage = styled.img`
  width: 100%;
`; 

export const ImageWrapper = styled.div`
  margin: 1rem 2rem;
  width: 40%;
  display: flex;
  align-items: center;
`;

export const StyledImage = styled.img`
  width: 100%;
`;